import React from "react";
import Modal from "../../commonComponents/util/Modal";
import ValidatedInput from "../../commonComponents/util/ValidatedInput";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";
import { convertToCSV, downloadCSV, formatDate, formatDateForInput } from "../../../lib/utils";

function getReportFields() {
  return {
    Recipient: [
      { label: "Name", value: "DisplayName", default: "" },
      { label: "Report Name", value: "ReportName", default: "" },
      { label: "Phone Number(s)", value: "PhoneNumber", default: "" },
      { label: "Email Address", value: "Email", default: "" },
      { label: "Address", value: "DisplayAddress", default: "" },
      { label: "Applicant Type", value: "ApplicantType", default: "" },
      { label: "Reference(s)", value: "References", default: "" },
      { label: "Solicitor(s)", value: "Solicitors", default: "" },
      { label: "Rosh Yeshiva(s)", value: "RoshYeshivas", default: "" },
      { label: "Campaign List(s)", value: "CampaignLists", default: "" },
      { label: "Notes", value: "RecipientNotes", default: "" },
      { label: "Total Paid", value: "TotalPaid", default: "" },
    ],
    Application: [
      { label: "Created By", value: "CreatedBy", default: "" },
      { label: "Creation Date", value: "CreationDate", default: "" },
      { label: "Status", value: "Status", default: "" },
      { label: "Amount", value: "Amount", default: "" },
      { label: "Currency", value: "Currency", default: "" },
      { label: "Reason", value: "Reason", default: "" },
      { label: "Fund", value: "Fund", default: "" },
      { label: "Check Date", value: "CheckOrWireDate", default: "" },
      { label: "Check #", value: "CheckOrWireNumber", default: "" },
      { label: "Check Memo", value: "CheckMemo", default: "" },
      { label: "Report Memo", value: "ReportMemo", default: "" },
      { label: "Approved By", value: "ApprovedBy", default: "" },
      { label: "Review Date", value: "ReviewDate", default: "" },
      { label: "Notes", value: "ApplicationNotes", default: "" },
    ]
  }
}

const initialState = {
  fields: [],
  startDate: "",
  endDate: "",
  error: false,
  noData: false,
  downloading: false,
  submitAttempted: false
};

export default class RecipientApplicationsReportModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onToggleReportFields = event => {
    const fieldName = event.target.name;
    const checked = event.target.checked;

    let fields = [...this.state.fields];
    if (checked) {
      fields.push(fieldName);
    } else {
      fields = fields.filter(f => f !== fieldName);
    }

    this.setState({ fields });
  };

  close() {
    this.setState(initialState);
    this.props.close();
  }

  async exportData() {
    this.setState({
      error: false,
      noData: false,
      submitAttempted: true
    });

    const { fields, startDate, endDate } = this.state;
    const { recipientId } = this.props;

    if (!fields.length) {
      return;
    }

    this.setState({
      downloading: true
    });

    try {
      const dateNow = `${new Date().toLocaleDateString().replace(/\//g, "_")}`;

      const reportFields = getReportFields();

      let params = {
        fields,
        recipientId,
        startDate,
        endDate
      };

      let exportRecipientHeaders = reportFields.Recipient.filter(
        field => fields.indexOf(field.value) >= 0
      );

      let exportApplicationHeaders = reportFields.Application.filter(
        field => fields.indexOf(field.value) >= 0
      );

      let reportName = `${this.props.recipientName} ${dateNow}`.replace(' ', '_');

      await this.props.getDataForExport(params);

      let response = this.props.export;
      if (!response.success) throw Error("error");

      const records = response.data.values;

      if (!records.length) throw Error("noData");

      const recipientHeadersCSV = (
        convertToCSV([
          { label: " ", value: "rowName", default: "" },
          { label: " ", value: "rowValue", default: "" },
        ], [
            { rowName: "Report Dates:", rowValue: startDate || endDate ? `${formatDate(startDate + " 00:00:0000")} - ${formatDate(endDate + " 00:00:0000")}` : '' },
            ...exportRecipientHeaders.map(field => ({ rowName: field.label, rowValue: records[0][field.value] }))
          ])
      );

      const csv = recipientHeadersCSV + "\r\n\r\n" + convertToCSV(exportApplicationHeaders, records);

      downloadCSV(csv, reportName + ".xls");

      this.setState({ downloading: false }, this.close);
    } catch (error) {
      this.setState({ downloading: false, [error.message || "error"]: true });
    }
  }

  render() {
    const {
      error,
      fields,
      startDate,
      endDate,
      downloading,
      noData,
      submitAttempted
    } = this.state;

    const {
      show
    } = this.props;

    const reportFields = getReportFields();

    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div className="modal new-fund-modal large-modal">
            <div className="bordered-modal-header">
              <h4 className="modal-page-header">
                Recipient Applications Report
              </h4>
              <i
                className="icon ion-ios-close-empty"
                onClick={this.close.bind(this)}
              />
            </div>
            <div className="modal-section">
              <div className="mb-16">
                {submitAttempted && !fields.length && (
                  <span className="xs-text error-text ml-8">
                    * Please select report fields
                    </span>
                )}
              </div>
              {Object.keys(reportFields).map((key, index) =>
                <div className="mb-16" key={index}>
                  <label className={`mb-16 input-label ${
                    submitAttempted && !fields.length ? "error-label" : ""
                    }`}>{key} Fields</label>

                  <div className="modal-row report-fields-grid">
                    {reportFields[key].map(field => (
                      <div className="custom-check-container" key={field.value}>
                        <input
                          type="checkbox"
                          id={`report-field-${field.value}`}
                          className="custom-check"
                          name={field.value}
                          onChange={this.onToggleReportFields}
                          checked={fields.indexOf(field.value) >= 0}
                        />
                        <label
                          htmlFor={`report-field-${field.value}`}
                          className="secondary-text"
                        >
                          {field.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="modal-row">
                <div className="column-half column-half-left">
                  <label className="input-label">
                    Between Dates
                    </label>
                  <div className="modal-row">
                    <div className="column-half">
                      <ValidatedInput
                        input={<input type="date" max={endDate} />}
                        value={formatDateForInput(startDate)}
                        name="startDate"
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="column-half">
                      <ValidatedInput
                        input={<input type="date" min={startDate} />}
                        value={formatDateForInput(endDate)}
                        name="endDate"
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className="modal-btns text-right">
              <button
                className="btn btn-accent"
                onClick={this.close.bind(this)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.exportData.bind(this)}
                disabled={downloading}
              >
                {downloading ? "Downloading Report" : "Download Report"}
              </button>
              <FadeOutErrorMessage show={error} />
              <FadeOutErrorMessage
                show={noData}
                message="No data was found."
                timeOut={5000}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientApplicationsReportModal.jsx